import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { filterPageTypes } from 'src/app/store/filters.era';
import { UserService } from 'src/app/services/user.service';
import { PAGE_NAME } from 'globals/store/permissions.data';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { TaskListPageComponent } from './task-list.page';

@Component({
    selector: 'my-task-list-page',
    template: `<app-task-list-page [isMyTasks]="true" [page_name]="page_name" [traceName]="traceName" [filterPage]="filterPage"></app-task-list-page>`,
    styleUrls: ['../../page.pass-through.scss'],
    standalone: true,
    imports: [TaskListPageComponent],
})
export class MyTaskListPageComponent implements OnInit, OnDestroy {
    page_name = PAGE_NAME.my_tasks;
    traceName = traceNames.viewMyTasksList;

    $destroy:Subject<boolean> = new Subject();
    filterPage = filterPageTypes.myTasks;

    constructor(public store: Store, private userService:UserService) {  }
    ngOnInit() { }
    ngOnDestroy() { this.$destroy.next(true); this.$destroy.complete(); }
}

